import { PaginationParams } from "@dune/types";

export const constructionSitesQueryKeys = {
	all: ["construction-sites"] as const,
	lists: () => [...constructionSitesQueryKeys.all, "lists"] as const,
	list: (
		search?: string,
		page?: number,
		limit?: number,
		brokerSocietyId?: number,
	) =>
		[
			...constructionSitesQueryKeys.lists(),
			search,
			page,
			limit,
			brokerSocietyId,
		] as const,
	details: () => [...constructionSitesQueryKeys.all, "details"] as const,
	detail: (id: string) =>
		[...constructionSitesQueryKeys.details(), id] as const,
	syndicInfo: (id: string) =>
		[...constructionSitesQueryKeys.all, "syndic-info", id] as const,
	clients: () => [...constructionSitesQueryKeys.all, "clients"] as const,
	clientSearch: (search: string, excludeSyndics = false) =>
		[...constructionSitesQueryKeys.clients(), search, excludeSyndics] as const,
	syndics: () => [...constructionSitesQueryKeys.all, "syndics"] as const,
	syndicSearch: (search: string) =>
		[...constructionSitesQueryKeys.syndics(), search] as const,
	binders: (id: number) =>
		[...constructionSitesQueryKeys.all, "binders", id] as const,
	documents: (id: number, pagination?: PaginationParams) =>
		[
			...constructionSitesQueryKeys.all,
			"documents",
			id,
			`${pagination?.page ?? 1}-${pagination?.limit ?? 10}-${pagination?.search ?? ""}-${pagination?.isReferenced ?? ""}`,
		] as const,
	communications: (
		constructionSiteId: string,
		options?: {
			page?: number;
			limit?: number;
			sortBy?: string;
			sortOrder?: "asc" | "desc";
		},
	) =>
		[
			...constructionSitesQueryKeys.all,
			"communications",
			constructionSiteId,
			options,
		] as const,
	communicationsAll: (constructionSiteId: number | string) =>
		[
			...constructionSitesQueryKeys.all,
			"communications",
			constructionSiteId,
		] as const,
	unprocessedCommunicationsCount: (constructionSiteId: string) =>
		[
			...constructionSitesQueryKeys.all,
			"communications",
			constructionSiteId,
			"unprocessed-count",
		] as const,
	submittableBindersAndWarranties: (constructionSiteId: string) =>
		[
			...constructionSitesQueryKeys.all,
			"submittable-binders-and-warranties",
			constructionSiteId,
		] as const,
	offers: (constructionSiteId: string) =>
		[...constructionSitesQueryKeys.all, "offers", constructionSiteId] as const,
	tasks: (constructionSiteId: string) =>
		[...constructionSitesQueryKeys.all, "tasks", constructionSiteId] as const,
	intervenants: (constructionSiteId: number) =>
		[
			...constructionSitesQueryKeys.all,
			"intervenants",
			constructionSiteId,
		] as const,
	publicCompletion: (constructionSiteId: number, token: string) =>
		[
			...constructionSitesQueryKeys.all,
			"public-completion",
			constructionSiteId,
			token,
		] as const,
};
